import * as React from 'react';

const TickFilledError = ({
  bgcolor = '',
  color = '',
  width = '30px',
  height = '30px',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Oval"
        d="M15.5 26C9.14873 26 4 20.8513 4 14.5C4 8.14873 9.14873 3 15.5 3C21.8513 3 27 8.14873 27 14.5C27 20.8513 21.8513 26 15.5 26Z"
        fill={bgcolor}
      />
      <path
        id="close"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5889 14.5L10.0611 9.86234C9.84631 9.64234 9.84615 9.28547 10.0607 9.06526C10.2753 8.84505 10.6234 8.84488 10.8382 9.06489L15.4624 13.8013C15.4874 13.7996 15.5124 13.7996 15.5374 13.8013L20.1616 9.06489C20.3764 8.84488 20.7245 8.84505 20.9391 9.06526C21.1537 9.28547 21.1535 9.64234 20.9387 9.86234L16.4109 14.5L20.9387 19.1377C21.1535 19.3577 21.1537 19.7145 20.9391 19.9347C20.7245 20.1549 20.3764 20.1551 20.1616 19.9351L15.5374 15.1987C15.5124 15.2004 15.4874 15.2004 15.4624 15.1987L10.8382 19.9351C10.6234 20.1551 10.2753 20.1549 10.0607 19.9347C9.84615 19.7145 9.84631 19.3577 10.0611 19.1377L14.5889 14.5Z"
        fill={color}
      />
    </svg>
  );
};

export default TickFilledError;
